// A non-blocking replacement for window.alert(): messages are rendered in
// the corner by <Toaster />, which App mounts once, so they also survive a
// route change.
export type ToastKind = "error" | "success";

export interface ToastMessage {
  id: number;
  kind: ToastKind;
  title: string;
  description?: string;
}

type Listener = (message: ToastMessage) => void;

const listeners = new Set<Listener>();
let nextId = 1;

const show = (kind: ToastKind, title: string, description?: string) => {
  const message = { id: nextId++, kind, title, description };
  listeners.forEach((listener) => listener(message));
};

export const toast = {
  error: (title: string, description?: string) => show("error", title, description),
  success: (title: string, description?: string) => show("success", title, description),
};

export const subscribeToToasts = (listener: Listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
